import { BqTag } from '~/components/ui/misc/bqTag/BqTag';

export function RestatedTagCellAg(props: { value: boolean | null }) {
  switch (props.value) {
    case null:
      return '-';
    case false:
      return '-';
    case true:
      return <BqTag color="warn" value="yes" />;
  }
}
